/**
 * [Pure] Compare two date values using string comparator.
 * @param initialValue - First date to compare.
 * @param comparator - Comparator string.
 * @param compareValue - Second date to compare (can be semantic).
 */
export function compareDate(initialValue: string | Date, comparator: string, compareValue?: any): boolean {
    // Get date for initial value.
    let dateValue: Date;
    if (typeof initialValue === "string"){
        if(initialValue === "today") dateValue = new Date();
        else dateValue = new Date(initialValue);
    }
    if (initialValue instanceof Date) dateValue = initialValue;

    // Get date for compare value.
    if (compareValue === "today") compareValue = new Date();
    else if (typeof compareValue === "string") compareValue = new Date(compareValue);

    // Compare dates.
    if (comparator === "<") return dateValue < compareValue;
    if (comparator === ">") return dateValue > compareValue;
    if (comparator === "!!") {
        if (!initialValue) return false;
        if (initialValue instanceof Date) return true;
        const dateValues = initialValue.split("/");
        if (dateValues.length === 2) return dateValues[0].length === 2 && dateValues[1].length === 2;                               // -> 09/21
        if (dateValues.length === 3) return dateValues[0].length === 2 && dateValues[1].length === 2 && dateValues[2].length === 4; // -> 09/21/1990
    }
    return false;
}
